import moment from 'moment'

// Chargebee sends dates as seconds; Morsel as ISO strings
export const day = (value) => {
  if (!value) return ''
  const m = typeof value === 'number' ? moment.unix(value) : moment(value)
  return m.format('MMM D, YYYY')
}

export const dollars = (n) => (n === null || n === undefined ? '' : `$${Number(n).toFixed(2)}`)

// Plan prices read better without ".00": $120 per year
const short = (n) => dollars(n).replace(/\.00$/, '')

export const priceText = (plan) => {
  if (!plan?.price) return ''
  const unit = plan.price.period_unit === 'month' ? 'month' : 'year'
  const people = plan.seats > 1 ? ` for up to ${plan.seats} people` : ''
  return `${short(plan.price.amount)} per ${unit}${people}`
}

export const familyButtonText = (plan) =>
  plan?.price ? `Family Pro, ${short(plan.price.amount)} a year for ${plan.seats}` : 'Family Pro'

const BRANDS = {
  visa: 'Visa',
  mastercard: 'Mastercard',
  american_express: 'American Express',
  discover: 'Discover',
}
export const cardBrand = (brand) =>
  BRANDS[brand] || (brand ? brand[0].toUpperCase() + brand.slice(1) : 'Card')
